import React, { useRef } from 'react';
import { Player } from '@lordicon/react';

import ICON from "./Json/heart.json";
import { Box, useTheme } from '@mui/material';

interface HeartButtonProps {
  isActive: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const HeartButton: React.FC<HeartButtonProps> = ({ isActive, onClick }) => {
  const theme = useTheme();
  const playerRef = useRef<Player>(null);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    playerRef.current?.playFromBeginning();
    onClick(event);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        '&:hover': { opacity: isActive ? .9 : .7, },
        cursor: 'pointer',
        opacity: isActive ? .9 : .3,
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        flexDirection: 'row',
      }}
    >
      <Player
        ref={playerRef}
        size={25}
        icon={ICON}
        colorize={isActive ? theme.palette.primary.main : theme.palette.text.primary}
        state="morph"
      />
    </Box>
  );
};
